// extracted by mini-css-extract-plugin
export var container = "_6o-0";
export var infoButton = "_6o-1";
export var label = "_6o-3";
export var labelExpanded = "_6o-4";
export var price = "_6o-5";
export var priceExpanded = "_6o-6";
export var title = "_6o-2";